// NOTE: NSAI-5650 — the fixed schedule behind `EThemePreference.AUTO`, read off
// the device's local clock: dark from DARK_START (inclusive) until DARK_END
// (exclusive), light for the rest of the day. Deliberately not user-configurable
// and deliberately not sunrise/sunset — a fixed pair of hours needs no
// geolocation permission and no extra persisted field, so `auto` costs exactly
// one more enum value on a column that already stores free-form text.
export const AUTO_THEME_DARK_START_HOUR = 19;

export const AUTO_THEME_DARK_END_HOUR = 7;

// NOTE: NSAI-5650 — floor for the "sleep until the next boundary" timer. The
// boundary is recomputed from the clock every time the timer fires, so a delay
// that lands on or just before `now` (a backwards clock correction, a DST shift)
// must still be a positive delay rather than a zero-length one that would spin
// the timer in a tight loop.
export const AUTO_THEME_MIN_BOUNDARY_DELAY_MS = 1000;
